
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
  },

  computed: {
    count() {
      return Math.floor(this.location.count / 10) * 10;
    },
  },
};
